export const STATIC_MAPS_DIV_ID = 'static-google-map-image';
